import { gqlClient } from '@/api/graphql-client';
import materialKeys from '@/api/queries/materials/keyFactory';
import { graphql } from '@/gql';
import {
  AddAccountPreferredProductInput,
  AddAccountPreferredProductMutation as AddAccountPreferredProductMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const AddAccountPreferredProductMutation = graphql(`
  mutation AddAccountPreferredProduct(
    $input: AddAccountPreferredProductInput!
  ) {
    addAccountPreferredProduct(input: $input) {
      material {
        id
        name
      }
      lineItem {
        id
      }
    }
  }
`);

const useAddAccountPreferredProduct = (
  options?: UseMutationOptions<
    AddAccountPreferredProductMutationResult,
    Error,
    AddAccountPreferredProductInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(AddAccountPreferredProductMutation, { input });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: materialKeys.accountPreferredProducts(),
      });
      void queryClient.invalidateQueries({
        queryKey: [...materialKeys.all, 'productSpecs'],
      });
    },
    ...options,
  });
};

export default useAddAccountPreferredProduct;
